@if (initialized) {
  <form [formGroup]="form">
    <div class="row">
      <div class="col-7">
        @if (!isNew) {
          <rask-input
            class="col-2"
            aid="mottagningsnummer"
            formControlName="mottagningsplatsnummer"
            label="{{ texts.mottagningsplatsnummer }}"
          [readonly]="true"></rask-input>
        }
        @if (isNew) {
          <rask-selector
            class="col-2"
            aid="mottagningsnummer"
            [label]="texts.mottagningsplatsnummer"
            formControlName="mottagningsplatsnummer"
            [viewFormatter]="sdcMottagningsplatsViewFormatter"
            [viewSelectedFormatter]="typeAheadViewSelectedFormatter"
            [formatter]="typeAheadViewSelectedFormatter"
            [search]="searchSDCMottagningsplatsByKod"
            [itemDisabled]="aktivMetodDisabled"
            [maxlength]="7">
          </rask-selector>
        }
        <rask-input
          aid="namn"
          class="col-3"
          label="{{ texts.namn }}"
          formControlName="namn"
        [rule]="validation.namn"></rask-input>
        <rask-selector
          class="col-3"
          aid="mottagningsplatstyp"
          formControlName="mottagningsplatstyp"
          label="Mottagningsplatstyp"
          [values]="mottagningsplatsTyper"
          [rule]="validation.mottagningsplatstyp">
        </rask-selector>
        <rask-selector class="col-3"
          aid="ansvarigLogistiker"
          [label]="texts.ansvariglogistiker"
          formControlName="ansvarigLogistiker"
          [viewFormatter]="typeAheadViewFormatter"
          [reverseLookup]="false"
          [formatter]="typeAheadValueFormatter"
          [search]="searchLogistikerTypeAhead">
        </rask-selector>
      </div>
      <div class="col-5">
        <rask-input
          aid="site"
          class="col-3"
          label="Site"
          formControlName="site"
        [readonly]="true"></rask-input>
        <rask-checkbox
          aid="aktiv"
          class="col-5"
          [text]="texts.aktiv"
          formControlName="aktiv"
        [checked]="mottagningsplats.aktiv"></rask-checkbox>
        @if (!isNew) {
          <rask-button
            aid="uppdateraFranViol3"
            class="col-4"
            (click)="syncMottagningsplats(mottagningsplats.mottagningsplatsnummer)">
            Hämta från Viol3
          </rask-button>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <rask-textarea class="col-5 fit-text-area"
          aid="namn"
          formControlName="beskrivning"
          [label]="texts.beskrivning"
          [rows]="3"
        [maxlength]="1000"></rask-textarea>
        <rask-input-number class="col-3"
          aid="northing"
          inputGroup="N"
          formControlName="northing"
        label="{{ texts.koordinater }}"></rask-input-number>
        <rask-input-number class="col-3"
          aid="easting"
          inputGroup="E"
        formControlName="easting"></rask-input-number>
      </div>
      <div class="col-5">
        <rask-checkbox
          aid="egenTerminal"
          class="col-3"
          text="Egen terminal"
          formControlName="egenTerminal"
        [checked]="mottagningsplats.egenTerminal"></rask-checkbox>
        <rask-checkbox
          aid="beraknaNarmasteIndustri"
          class="col-6"
          [text]="texts.beraknaNarmasteIndustri"
          formControlName="beraknaNarmasteIndustri"
        [checked]="mottagningsplats.beraknaNarmasteIndustri "></rask-checkbox>
      </div>
    </div>
  </form>
}
